import { Injectable } from '@angular/core';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from 'exceljs';
import * as FileSaver from 'file-saver';
@Injectable()
export class ExcelService {
    constructor() { }
    static toExportFileName(excelFileName: string): string {
        return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
    }
    public exportAsExcelFile(
        json: any[],
        excelFileName: string,
        rowCount: number
    ): void {
        let workbook = new Excel.Workbook();
        var worksheet = workbook.addWorksheet(excelFileName);
        var columns = [];
        for (const key in json[0]) {
            columns.push({
                header: key,
                key: key,
                width: 30
            });
        }
        worksheet.columns = columns;

        worksheet.addRows(json);
        worksheet.views = [
            {
                showGridLines: false
            }
        ];
        for (let i = 1; i <= rowCount + 1; i++) {
            var row = worksheet.getRow(i);
            row.alignment = {
                vertical: 'middle',
                horizontal: 'center',
                wrapText: true
            };
            row.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'bec7f3' },
                bgColor: { argb: 'bec7f3' }
            };
            if (i == 1) {
                row.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '5867dd' },
                    bgColor: { argb: '5867dd' }
                };
                row.font = {
                    color: { argb: 'ffffff' },
                    bold: true
                };
            } else {
                row.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '5867dd' },
                    bgColor: { argb: '5867dd' }
                };
                row.getCell(1).font = {
                    color: { argb: 'ffffff' },
                    bold: true
                };
            }
            row.border = {
                top: { style: 'double', color: { argb: 'ffffff' } },
                left: { style: 'double', color: { argb: 'ffffff' } },
                bottom: { style: 'double', color: { argb: 'ffffff' } },
                right: { style: 'double', color: { argb: 'ffffff' } }
            };
            row.height = 45;
        }
        workbook.xlsx
            .writeBuffer()
            .then(buffer =>
                FileSaver.saveAs(
                    new Blob([buffer]),
                    `${excelFileName}_${Date.now()}.xlsx`
                )
            )
            .catch(err => console.log('Error writing excel export', err));
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/excel.sevice.ts